const state = {
  userProfile: {},
  isLoadingPage: false,
  isLoadingS3: false,
  warningServiceModal: false,
  s3Info: {},
  regions: [],
  portalLocked: false,
  portalLockChecked: false,
  // Access/refresh token issued at login for an account with OTP enabled, before the OTP
  // step is completed. Kept in memory only (never persisted to cookies/localStorage) so it
  // cannot be replayed against other APIs and is lost on page reload, forcing a fresh login.
  pendingOtpAuth: null,
};

const getters = {
  userProfile(state) {
    return state.userProfile;
  },
  isLoadingPage(state) {
    return state.isLoadingPage;
  },
  isLoadingS3(state) {
    return state.isLoadingS3;
  },
  warningServiceModal(state) {
    return state.warningServiceModal
  },
  s3Info(state) {
    return state.s3Info;
  },
  regions(state) {
    return state.regions;
  },
  portalLocked(state) {
    return state.portalLocked;
  },
  pendingOtpAuth(state) {
    return state.pendingOtpAuth;
  },
};

const actions = {
  updateUserProfile({ commit }, userProfile) {
    commit("UPDATE_USER_PROFILE", userProfile);
  },
  updateIsLoadingPage({ commit }, isLoadingPage) {
    commit("UPDATE_IS_LOADING_PAGE", isLoadingPage);
  },
  updateRegions({ commit }, regions) {
    commit("UPDATE_REGIONS", regions);
  },
  updateIsLoadingS3({ commit }, isLoadingS3) {
    commit('UPDATE_IS_LOADING_S3', isLoadingS3);
  },
  updateWarningServiceModal({commit}, warningServiceModal) {
    commit('UPDATE_WARNING_SERVICE_MODAL', warningServiceModal)
  },
  updateS3Info({commit}, s3Info) {
    commit('UPDATE_S3INFO', s3Info)
  },
  updatePortalLocked({ commit }, portalLocked) {
    commit('UPDATE_PORTAL_LOCKED', portalLocked);
  },
  updatePortalLockChecked({ commit }, portalLockChecked) {
    commit('UPDATE_PORTAL_LOCK_CHECKED', portalLockChecked);
  },
  setPendingOtpAuth({ commit }, pendingOtpAuth) {
    commit('SET_PENDING_OTP_AUTH', pendingOtpAuth);
  },
};

const mutations = {
  UPDATE_USER_PROFILE(state, userProfile) {
    state.userProfile = userProfile;
  },
  UPDATE_IS_LOADING_PAGE(state, isLoadingPage) {
    state.isLoadingPage = isLoadingPage;
  },
  UPDATE_IS_LOADING_S3(state, isLoadingS3) {
    state.isLoadingS3 = isLoadingS3;
  },
  UPDATE_WARNING_SERVICE_MODAL(state, warningServiceModal) {
    state.warningServiceModal = warningServiceModal;
  },
  UPDATE_S3INFO(state, s3Info) {
    state.s3Info = s3Info;
  },
  UPDATE_REGIONS(state, regions) {
    state.regions = regions;
  },
  UPDATE_PORTAL_LOCKED(state, portalLocked) {
    state.portalLocked = portalLocked;
  },
  UPDATE_PORTAL_LOCK_CHECKED(state, portalLockChecked) {
    state.portalLockChecked = portalLockChecked;
  },
  SET_PENDING_OTP_AUTH(state, pendingOtpAuth) {
    state.pendingOtpAuth = pendingOtpAuth;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
